import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/EntityGrid";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers/AssetHelpers";
import { startCase } from "lodash";
import { KTSVG } from "src/_metronic/helpers";
import { ActionButton } from "src/app/components";
import { Order } from "src/app/types/orders/order";

const useFillingGridColumns = (
    action: (modal: "edit", data: Order) => void
): Array<SimpleEntityGridColumn> => {
    const { formatMessage } = useIntl();
    return [
        {
            field: "id",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            headerName: "id",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "domain",
            headerName: formatMessage({ id: "sites.grid.col.domain" }),
            pinned: "left",
        },
        {
            field: "lang",
            headerName: formatMessage({ id: "keywords.grid.col.lang" }),
            minWidth: 60,
            maxWidth: 60,
            cellRenderer: ({ data }: any) => {
                return (
                    <SVG
                        width={16}
                        src={toAbsoluteUrl(`/media/flags/${data?.lang?.toLowerCase()}.svg`)}
                    />
                );
            },
            filter: "agSetColumnFilter",
        },
        {
            field: "keywords",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => {
                return data?.keywords;
            },
            cellRenderer: ({ data }: any) => (
                <div className="thematic-react-tag-wrapper gap-2 pb-2 pt-2">
                    {data?.keywords?.map((category: string, index: number) => (
                        <div key={index} className="thematic-react-tag">
                            {category}
                        </div>
                    ))}
                </div>
            ),
            minWidth: 400,
            maxWidth: 400,
        },
        {
            field: "title",
            valueGetter: ({ data }: any) => data?.title,
            onCellClicked: ({ data }: any) => {
                window.open(data.url, "_blank", "noreferrer");
            },
            headerName: formatMessage({ id: "content.grid.col.title" }),
            minWidth: 350,
            maxWidth: 350,
        },
        {
            field: "metaTitle",
            headerName: formatMessage({ id: "content.grid.col.meta-title" }),
            minWidth: 350,
            maxWidth: 350,
        },
        {
            field: "metaDescription",
            headerName: formatMessage({ id: "content.grid.col.meta-description" }),
            minWidth: 400,
            maxWidth: 400,
        },
        {
            field: "actions",
            minWidth: 122.75,
            maxWidth: 122.75,
            cellRenderer: ({ data }: { data: Order }) => {
                return (
                    <>
                        <ActionButton actions={["edit"]} name="edit" data={data}>
                            <a
                                onClick={() => action("edit", data)}
                                title={startCase(formatMessage({ id: "common.action.edit" }))}
                                className="inline-action"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/art/art005.svg"
                                    className="svg-icon-2"
                                />
                            </a>
                        </ActionButton>
                    </>
                );
            },
        },
    ];
};

export default useFillingGridColumns;
